import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const MobileBottomNavigation = () => {
  // Component has been disabled as per client request to remove the sticky navbar at the bottom in mobile mode
  return null;
};

export default MobileBottomNavigation;
